import { render } from "./AMenu.vue?vue&type=template&id=90c6b90c"
import script from "./AMenu.vue?vue&type=script&lang=js"
export * from "./AMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__